import general from './general.json';
import auth from './auth.json';
import home from './home.json';
import publicSearch from './publicSearch.json';
import agreements from './agreements.json';
import userManagement from './userManagement.json';
import statistics from './statistics.json';
import accounts from './accounts.json';
import branding from './branding.json';
import masterList from './masterList.json';
import journalsIntelligence from './journalsIntelligence.json';
import announcements from './announcements.json';

export const en = {
  translation: {
    general,
    auth,
    home,
    publicSearch,
    agreements,
    userManagement,
    statistics,
    accounts,
    branding,
    masterList,
    journalsIntelligence,
    announcements,
  },
};
